import { LoaderStep } from '@/components/ui/MultiStepLoader.tsx';

/**
 * Kroki nakładki na czas składania rezerwacji.
 *
 * Pierwszy i ostatni mówią prawdę o tym, co się dzieje — to na nich stoi cała
 * wiarygodność ekranu. Środek jest obozowym żartem i nie udaje postępu: oś
 * zatrzymuje się na przedostatnim („Przybijamy pieczątkę”), dopóki backend nie
 * potwierdzi rezerwacji.
 */
export const BOOKING_PROGRESS_STEPS: LoaderStep[] = [
  { text: 'Sprawdzamy wolne miejsca' },
  { text: 'Pakujemy plecak' },
  { text: 'Szukamy latarki (zawsze się gubi)' },
  { text: 'Ostrzymy kredki dla kadry' },
  { text: 'Rezerwujemy miejsce przy ognisku' },
  { text: 'Przybijamy pieczątkę' },
  { text: 'Gotowe — rezerwacja przyjęta!' },
];
